"use client";

import { X, tw, t, Y } from "@reframe.so/blocks";
import { Recipe } from "@src/app/recipes/constants";
import { Markdown } from "@src/components/markdown";
import { Section } from "@src/components/section";
import { useRef } from "react";

const IFrame = tw("iframe", t`absolute top-0 left-0 w-full h-full border-0`);

export function Client({ recipe }: { recipe: Recipe }) {
  const container = useRef<HTMLDivElement>(null);

  const sections = recipe.sections;

  const gotoStep = (step: number) => {
    container.current
      ?.querySelectorAll(`[data-component=section]:nth-child(${step})`)[0]
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  };

  return (
    <Y ref={container} css="py-8">
      {sections.map((section, index) => (
        <Section
          key={index}
          title={section.title}
          subtitle={
            <Markdown css="bg-transparent" content={section.subtitle} />
          }
          primaryAction={
            index === sections.length - 1
              ? undefined
              : {
                  label: "Next",
                  onClick: () => gotoStep(index + 2),
                }
          }
          secondaryAction={
            index === 0
              ? undefined
              : {
                  label: "Back",
                  onClick: () => gotoStep(index),
                }
          }
        >
          <X css="relative pb-[calc(64.4375%+44px)] h-0  rounded-md">
            <IFrame
              src={section.src}
              allowFullScreen
              css="border-0"
              style={{ border: "0" }}
            />
          </X>
        </Section>
      ))}
    </Y>
  );
}
